import { render } from "./BeFooter.vue?vue&type=template&id=4514bddd&scoped=true&ts=true"
import script from "./BeFooter.vue?vue&type=script&lang=ts"
export * from "./BeFooter.vue?vue&type=script&lang=ts"

import "./BeFooter.vue?vue&type=style&index=0&id=4514bddd&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4514bddd"]])

export default __exports__